import * as core from '../../../../../../../core'

import { query } from './requirements-dashboard-status-donut.query'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard.status-donut',
    description:
      'Breakdown of requirements by their canonical Jira status, click a slice to filter the table below',
    name: 'Requirements Dashboard - Status Donut',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
